module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n  var DnsMode = require(\'./NetSimConstants\').DnsMode;\n  var i18n = require(\'@cdo/netsim/locale\');\n\n  /**\n   * @param {exports.DnsMode} mode\n   * @param {string} label\n   */\n  function makeRadio(mode, label) {\n    %>\n    <div class="dns_mode_<%= mode %>">\n      <input id="dns_mode_<%= mode %>"\n                   type="radio"\n                   name="dns_mode"\n                   value="<%= mode %>" />\n      <label for="dns_mode_<%= mode %>"><%= label %></label>\n    </div>\n    <%\n  }\n%>\n<div class="dns-mode-control">\n  <h1><%= i18n.dnsMode() %></h1>\n  <% makeRadio(DnsMode.NONE, i18n.dnsMode_NONE()); %>\n  <% makeRadio(DnsMode.MANUAL, i18n.dnsMode_MANUAL()); %>\n  <% makeRadio(DnsMode.AUTOMATIC, i18n.dnsMode_AUTOMATIC()); %>\n</div>\n', __filename = "src/netsim/NetSimDnsModeControl.html.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var DnsMode = require("./NetSimConstants").DnsMode;
        var i18n = require("@cdo/netsim/locale");
        function makeRadio(mode, label) {
            __line = 10;
            __append('\n    <div class="dns_mode_');
            __line = 11;
            __append(escapeFn(mode));
            __append('">\n      <input id="dns_mode_');
            __line = 12;
            __append(escapeFn(mode));
            __append('"\n                   type="radio"\n                   name="dns_mode"\n                   value="');
            __line = 15;
            __append(escapeFn(mode));
            __append('" />\n      <label for="dns_mode_');
            __line = 16;
            __append(escapeFn(mode));
            __append('">');
            __append(escapeFn(label));
            __append("</label>\n    </div>\n    ");
            __line = 18;
        }
        __line = 20;
        __append('\n<div class="dns-mode-control">\n  <h1>');
        __line = 22;
        __append(escapeFn(i18n.dnsMode()));
        __append("</h1>\n  ");
        __line = 23;
        makeRadio(DnsMode.NONE, i18n.dnsMode_NONE());
        __append("\n  ");
        __line = 24;
        makeRadio(DnsMode.MANUAL, i18n.dnsMode_MANUAL());
        __append("\n  ");
        __line = 25;
        makeRadio(DnsMode.AUTOMATIC, i18n.dnsMode_AUTOMATIC());
        __append("\n</div>\n");
        __line = 27;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}